/* eslint-disable quotes */
// components.application.rewards.redeem.viewReward.overview

export const REWARD_OVERVIEW = {
  about: {
    title: 'About',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
  },
  specs: {
    title: 'Product Specs',
    created: 'Created:',
    fileType: 'File Type(s):',
    fileSize: 'File Size:'
  },
  preview: {
    title: 'Preview'
  }
};
